import api from '@state/api';
const workerEndPoint = `${process.env.WORKER_API}/workerapi/v1`;
export const getEventLog = async (deviceId) => {
    const { data } = await api.get(`${workerEndPoint}/eventLog/${deviceId}`);
    return data;
};
